import {
    Avatar, Box, Button, Card,
    CardContent,
    CardHeader, Container, Dialog,
    DialogContent, FormControl, Grid, IconButton, InputAdornment, InputLabel, List,
    ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, MenuItem, Select, TextField, Typography, useTheme
} from "@material-ui/core";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import {
    Close, FileCopy, HighlightOff
} from "@material-ui/icons";
import moment from "moment";
import "moment-timezone";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";
import toastr from "toastr";
import calendarIcon from "../../assets/images/calendar.svg";
import descIcon from "../../assets/images/desc.svg";
import pic1 from "../../assets/images/setUpMeetingDesc.png";
import pic2 from "../../assets/images/setUpMeetingInvite.png";
import pic3 from "../../assets/images/setUpMeetingSch.png";
import pic from "../../assets/images/setUpMeetingTitle.png";
import videoIcon from "../../assets/images/video.svg";
import { useStyles } from "../../components/common/MainStyles.jsx";
import { IsNullOrEmpty, pad, validEmail } from "../../helpers/utility";
import { getProductList } from "../../store/shopping/shopping.selector";
import { createLiveStreamRequest } from "../../store/social/social.actions";
import { getLiveStream } from "../../store/social/social.selector";
import { searchUserRequest } from "../../store/user/user.actions";
import {
    getImage,
    getSearchedUsers,
    getUserProfile
} from "../../store/user/user.selector";

export default function CreateMeetingRoom(props) {
    const dispatch = useDispatch();
    const history = useNavigate();
    const classes = useStyles();
    const theme = useTheme();
    const [disabled, setDisabled] = useState(false);
    const [guests, setGuests] = useState([]);
    const [showSummary, setSummary] = useState(false);
    const [title, setTitle] = useState("");
    const [email, setEmail] = useState("");
    const [description, setDescription] = useState("");
    const [selectedMenu, setSelectedMenu] = useState("title");
    const [isInvited, setInvited] = useState(false);
    const [emails, setEmails] = useState([]);
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    function getSteps() {
        return ["Title", "Description", "Invite", "Schedule"];
    }

    function getStepContent(stepIndex) {
        switch (stepIndex) {
            case 0:
                return (
                    <Container maxWidth="xl" className="my-4">
                        <Box className="mb-4">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                Give a name to your live
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                Make it easier for people to find
                            </Typography>
                        </Box>
                        <Box
                            height="100%"
                            minHeight={"49.5vh"}
                            display={"flex"}
                            justifyContent="space-between"
                            flexDirection={"column"}
                        >
                            <TextField
                                label="Title"
                                fullWidth
                                variant="outlined"
                                placeholder="Title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                className="my-2 bg-white"
                            />
                            <div className="my-4">
                                <Button
                                    variant="contained"
                                    onClick={() => props.onClose()}
                                    className={classes.bgwhite}
                                >
                                    Previous
                                </Button>
                                <Button
                                    variant="contained"
                                    className="ml-2"
                                    color={
                                        !IsNullOrEmpty(title)
                                            ? "secondary"
                                            : "default"
                                    }
                                    disabled={IsNullOrEmpty(title)}
                                    onClick={() => handleNext()}
                                >
                                    Next
                                </Button>
                            </div>
                        </Box>
                    </Container>
                );
            case 1:
                return (
                    <Container maxWidth="xl" className="my-4">
                        <Box className="mb-4">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                Describe your live
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                Tell the audience more about your live
                            </Typography>
                        </Box>
                        <Box
                            height="100%"
                            minHeight={"49.5vh"}
                            display={"flex"}
                            justifyContent="space-between"
                            flexDirection={"column"}
                        >
                            <div>
                                <TextField
                                    label="Your description"
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Your description"
                                    minRows={4}
                                    multiline
                                    inputProps={{
                                        maxLength: 80,
                                    }}
                                    value={description}
                                    onChange={(e) =>
                                        setDescription(e.target.value)
                                    }
                                    className="my-2 bg-white"
                                    helperText={
                                        description.length > 0 ? (
                                            <span className="float-right text-danger">{`${80 - description.length
                                                } characters remaining`}</span>
                                        ) : (
                                            ""
                                        )
                                    }
                                />

                                {IsNullOrEmpty(description) ? (
                                    <>
                                        <p className="text-disabled mb-4 text-grey text-small">
                                            Max 80 characters
                                        </p>
                                    </>
                                ) : (
                                    <span />
                                )}
                            </div>
                            <div className="my-4">
                                <Button
                                    variant="contained"
                                    onClick={() => handleBack()}
                                    className={classes.bgwhite}
                                >
                                    Previous
                                </Button>
                                <Button
                                    variant="contained"
                                    className="ml-2"
                                    color={
                                        !IsNullOrEmpty(description)
                                            ? "secondary"
                                            : "default"
                                    }
                                    disabled={IsNullOrEmpty(description)}
                                    onClick={() => handleNext()}
                                >
                                    Next
                                </Button>
                            </div>
                        </Box>
                    </Container>
                );
            case 2:
                return (
                    <Container maxWidth="xl" className="my-2">
                        <Dialog open={isInvited} maxWidth="sm" fullWidth>
                            <DialogContent>
                                <Typography
                                    variant="h5"
                                    component="p"
                                    className={classes.title}
                                >
                                    Enter email
                                    <HighlightOff
                                        color="action"
                                        className="float-right"
                                        onClick={() => setInvited(false)}
                                    />
                                </Typography>
                                <Box
                                    height="100%"
                                    minHeight={"49.5vh"}
                                    display={"flex"}
                                    justifyContent="space-between"
                                    flexDirection={"column"}
                                >
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        margin="dense"
                                        value={email}
                                        onChange={(e) =>
                                            setEmail(e.target.value)
                                        }
                                        onKeyPress={(e) => {
                                            if (
                                                e.key.toLowerCase() === "enter"
                                            ) {
                                                if (validEmail(email)) {
                                                    setEmails([
                                                        ...emails,
                                                        email,
                                                    ]);
                                                    setEmail("");
                                                }
                                            }
                                        }}
                                        placeholder="Email address"
                                    />
                                    <List className="my-2" disablePadding>
                                        {emails.length > 0 ? (
                                            emails.map((x, index) => {
                                                return (
                                                    <ListItem
                                                        disableGutters
                                                        className="p-0"
                                                    >
                                                        <ListItemText
                                                            primaryTypographyProps={{
                                                                style: {
                                                                    color: theme
                                                                        .palette
                                                                        .primary
                                                                        .main,
                                                                    fontStyle:
                                                                        "italic",
                                                                },
                                                            }}
                                                            primary={
                                                                index +
                                                                1 +
                                                                ". " +
                                                                x
                                                            }
                                                        />
                                                        <ListItemSecondaryAction>
                                                            <Close
                                                                onClick={() =>
                                                                    setEmails(
                                                                        emails.filter(
                                                                            (
                                                                                y
                                                                            ) =>
                                                                                y !==
                                                                                x
                                                                        )
                                                                    )
                                                                }
                                                            />
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                );
                                            })
                                        ) : (
                                            <span />
                                        )}
                                    </List>
                                    <Button
                                        fullWidth
                                        className="mb-4"
                                        color="secondary"
                                        variant="contained"
                                        onClick={() => setInvited(false)}
                                    >
                                        Send Invitation
                                    </Button>
                                </Box>
                            </DialogContent>
                        </Dialog>
                        <Box className="my-2">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                Invite friends to your meeting
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                Only person you choose will be in the meeting
                            </Typography>
                        </Box>
                        <Box
                            height="100%"
                            minHeight={"49.5vh"}
                            display={"flex"}
                            justifyContent="space-between"
                            flexDirection={"column"}
                        >
                            <div className="relative mb-3.5">
                                <input
                                    value={searchText}
                                    onChange={(e) =>
                                        setSearchText(e.target.value)
                                    }
                                    type="search"
                                    className="py-2.5 pl-12 w-full text-black-color placeholder:text-black-60 border border-black-10 rounded-[40px] text-md sm:text-md outline-none"
                                    placeholder="Search"
                                />

                                <span className="text-xl absolute top-2/4 -translate-y-2/4 left-5 text-black-60">
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29583 11.5892 8.49572 10.8907 9.47653L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47653 10.8907C8.49572 11.5892 7.29583 12 6 12C2.68629 12 0 9.31371 0 6Z"
                                            fill="black"
                                            fillOpacity="0.5"
                                        />
                                    </svg>
                                </span>
                            </div>
                            <Grid
                                container
                                spacing={2}
                                className={classes.guestList}
                            >
                                {guestUsers.map((item) => {
                                    let isActive =
                                        guests.indexOf(item._id) > -1;
                                    return (
                                        <Grid
                                            item
                                            key={item._id}
                                            sm={4}
                                            xs={4}
                                            md={2}
                                            lg={2}
                                        >
                                            <Box
                                                textAlign="center"
                                                display={"flex"}
                                                justifyContent="center"
                                                alignItems={"center"}
                                                flexDirection={"column"}
                                            >
                                                <Avatar
                                                    style={{
                                                        height: 64,
                                                        width: 64,
                                                        border: isActive
                                                            ? "3px solid " +
                                                            theme.palette
                                                                .primary.main
                                                            : "1px solid " +
                                                            theme.palette
                                                                .grey[800],
                                                    }}
                                                    src={
                                                        props.category.name ===
                                                            "VIP Circle"
                                                            ? item.thumbnail
                                                            : getImage(
                                                                item.attachments
                                                            )
                                                    }
                                                    title={item.fullName}
                                                    alt={item.fullName}
                                                    onClick={() => {
                                                        let index =
                                                            guests.findIndex(
                                                                (x) =>
                                                                    x ===
                                                                    item._id
                                                            );
                                                        if (index > -1) {
                                                            let newGuests =
                                                                guests.filter(
                                                                    (y) =>
                                                                        y !==
                                                                        item._id
                                                                );
                                                            setGuests(
                                                                newGuests
                                                            );
                                                        } else {
                                                            setGuests([
                                                                ...guests,
                                                                item._id,
                                                            ]);
                                                        }
                                                    }}
                                                />
                                                <span
                                                    className="overflow-text text-small"
                                                    title={item.fullName}
                                                    style={{
                                                        color: isActive
                                                            ? theme.palette
                                                                .primary.main
                                                            : theme.palette
                                                                .grey[800],
                                                    }}
                                                >
                                                    {item.fullName}
                                                </span>
                                            </Box>
                                        </Grid>
                                    );
                                })}
                            </Grid>

                            <div className="my-4">
                                <Button
                                    variant="contained"
                                    onClick={() => handleBack()}
                                    className={classes.bgwhite}
                                >
                                    Previous
                                </Button>
                                <Button
                                    className="ml-2"
                                    variant="contained"
                                    color={"secondary"}
                                    onClick={() => {
                                        handleNext();
                                    }}
                                >
                                    Next
                                </Button>
                                <Button
                                    className="float-right"
                                    variant="outlined"
                                    onClick={() => setInvited(true)}
                                >
                                    Send invite through email
                                </Button>
                            </div>
                        </Box>
                    </Container>
                );
            case 3:
                return (
                    <Container
                        maxWidth="xl"
                        className="my-4"
                        className="mini-text"
                    >
                        <Box className="mb-4">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                Schedule Meeting
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                Customize your event
                            </Typography>
                        </Box>
                        <Box
                            height="100%"
                            minHeight={"49.5vh"}
                            display={"flex"}
                            justifyContent="space-between"
                            flexDirection={"column"}
                        >
                            <Grid container spacing={1}>
                                <Grid item xs={4} sm={4}>
                                    <InputLabel className="mb-1 text-sm">
                                        Day
                                    </InputLabel>
                                    <FormControl variant="outlined" fullWidth>
                                        <Select
                                            margin="dense"
                                            fullWidth
                                            value={values.day}
                                            onChange={(e) =>
                                                setValues({
                                                    ...values,
                                                    day: e.target.value,
                                                })
                                            }
                                        >
                                            {[...Array(31).keys()].map((x) => {
                                                return (
                                                    <MenuItem
                                                        value={pad(x + 1, 2)}
                                                    >
                                                        {pad(x + 1, 2)}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4} sm={4}>
                                    <InputLabel className="mb-1 text-sm">
                                        Month
                                    </InputLabel>
                                    <FormControl variant="outlined" fullWidth>
                                        <Select
                                            margin="dense"
                                            fullWidth
                                            value={values.month}
                                            onChange={(e) =>
                                                setValues({
                                                    ...values,
                                                    month: e.target.value,
                                                })
                                            }
                                        >
                                            {[...Array(12).keys()].map((x) => {
                                                return (
                                                    <MenuItem
                                                        value={pad(x + 1, 2)}
                                                    >
                                                        {pad(x + 1, 2)}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4} sm={4}>
                                    <InputLabel className="mb-1 text-sm">
                                        Year
                                    </InputLabel>
                                    <FormControl variant="outlined" fullWidth>
                                        <Select
                                            margin="dense"
                                            fullWidth
                                            value={values.year}
                                            onChange={(e) =>
                                                setValues({
                                                    ...values,
                                                    year: e.target.value,
                                                })
                                            }
                                        >
                                            {[...Array(2).keys()].map((x) => {
                                                return (
                                                    <MenuItem
                                                        value={pad(
                                                            parseInt(
                                                                moment().format(
                                                                    "YYYY"
                                                                )
                                                            ) + parseInt(x),
                                                            2
                                                        )}
                                                    >
                                                        {pad(
                                                            parseInt(
                                                                moment().format(
                                                                    "YYYY"
                                                                )
                                                            ) + parseInt(x),
                                                            2
                                                        )}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4} sm={4}>
                                    <InputLabel className="center-label mt-3 text-sm">
                                        Set Time
                                    </InputLabel>
                                </Grid>
                                <Grid item xs={8} sm={8}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={4} sm={4}>
                                            <FormControl
                                                variant="outlined"
                                                fullWidth
                                            >
                                                <Select
                                                    margin="dense"
                                                    fullWidth
                                                    value={values.hour}
                                                    onChange={(e) =>
                                                        setValues({
                                                            ...values,
                                                            hour: e.target
                                                                .value,
                                                        })
                                                    }
                                                >
                                                    {[...Array(11).keys()].map(
                                                        (x) => {
                                                            return (
                                                                <MenuItem
                                                                    value={pad(
                                                                        x + 1,
                                                                        2
                                                                    )}
                                                                >
                                                                    {pad(
                                                                        x + 1,
                                                                        2
                                                                    )}
                                                                </MenuItem>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4} sm={4}>
                                            <FormControl
                                                variant="outlined"
                                                fullWidth
                                            >
                                                <Select
                                                    margin="dense"
                                                    fullWidth
                                                    value={values.minute}
                                                    onChange={(e) =>
                                                        setValues({
                                                            ...values,
                                                            minute: e.target
                                                                .value,
                                                        })
                                                    }
                                                >
                                                    <MenuItem value={"00"}>
                                                        00
                                                    </MenuItem>
                                                    {[...Array(59).keys()].map(
                                                        (x) => {
                                                            return (
                                                                <MenuItem
                                                                    value={pad(
                                                                        x + 1,
                                                                        2
                                                                    )}
                                                                >
                                                                    {pad(
                                                                        x + 1,
                                                                        2
                                                                    )}
                                                                </MenuItem>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4} sm={4}>
                                            <FormControl
                                                variant="outlined"
                                                fullWidth
                                            >
                                                <Select
                                                    margin="dense"
                                                    fullWidth
                                                    value={values.meridian}
                                                    onChange={(e) =>
                                                        setValues({
                                                            ...values,
                                                            meridian:
                                                                e.target.value,
                                                        })
                                                    }
                                                >
                                                    <MenuItem value="am">
                                                        AM
                                                    </MenuItem>
                                                    <MenuItem value="pm">
                                                        PM
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={4} sm={4}>
                                    <InputLabel className="center-label mt-3 text-sm">
                                        Time Zone
                                    </InputLabel>
                                </Grid>
                                <Grid item xs={8} sm={8}>
                                    <FormControl variant="outlined" fullWidth>
                                        <Select
                                            margin="dense"
                                            fullWidth
                                            value={values.timeZone}
                                            onChange={(e) =>
                                                setValues({
                                                    ...values,
                                                    timeZone: e.target.value,
                                                })
                                            }
                                        >
                                            {timeZones.map((x) => {
                                                return (
                                                    <MenuItem value={x}>
                                                        {x} (UTC{" "}
                                                        {moment()
                                                            .tz(x)
                                                            .format("Z")}
                                                        )
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <div className="my-4">
                                        <Button
                                            variant="outlined"
                                            disabled={disabled}
                                            onClick={() =>
                                                handleCreateLiveStream()
                                            }
                                        >
                                            Start Now
                                        </Button>

                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            disabled={disabled}
                                            className="ml-2"
                                            onClick={() =>
                                                handleCreateLiveStream(true)
                                            }
                                        >
                                            Schedule Later
                                        </Button>

                                        <Button
                                            className="float-right"
                                            variant="outlined"
                                            onClick={() => handleBack()}
                                        >
                                            Previous
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                );
            default:
                return "Unknown stepIndex";
        }
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const [values, setValues] = useState({
        day: moment().add(30, "minutes").format("DD"),
        month: moment().add(30, "minutes").format("MM"),
        year: moment().add(30, "minutes").format("YYYY"),
        hour: moment().add(30, "minutes").format("hh"),
        minute: moment().add(30, "minutes").format("mm"),
        meridian: moment().add(30, "minutes").format("a"),
        timeZone: moment.tz.guess(),
    });

    const [searchText, setSearchText] = useState("");
    let guestUsers = [];

    const { products, userProfile, allUsers, livestream } = useSelector(
        (state) => {
            return {
                products: getProductList(state),
                allUsers: getSearchedUsers(state),
                livestream: getLiveStream(state),
                userProfile: getUserProfile(state),
            };
        }
    );

    useEffect(() => {
        if (
            livestream._id &&
            livestream.category === props.category._id &&
            livestream.contents === description &&
            livestream.title === title
        ) {
            setSummary(true);
        }
    }, [livestream]);

    useEffect(() => {
        // dispatch(fetchLiveStreamByIdSuccess({ data: {} }));
        dispatch(searchUserRequest());
    }, []);

    const handleCreateLiveStream = (sch) => {
        setDisabled(true);
        setTimeout(() => {
            setDisabled(false);
        }, 5000);
        let data = {
            type: "main",
            category: props.category._id,
            title: title,
            contents: description,
            products: products.map((x) => {
                return {
                    id: x._id,
                    name: x.name,
                };
            }),
            guests: guestUsers.filter((x) => guests.indexOf(x._id) > -1),
            hashtags: [],
            emails: emails,
        };
        if (products.length > 0) {
            data.currentProduct = products[0]._id;
        }

        if (sch) {
            data.timeStart = moment(
                `${values.year}-${values.month}-${values.day} ${values.hour}:${values.minute}:${values.meridian}`,
                "YYYY-MM-DD hh:mm:a"
            )
                .tz(values.timeZone)
                .format();
        }
        if (sch) {
            console.log(
                moment(data.timeStart).diff(
                    moment().tz(values.timeZone),
                    "minutes"
                )
            );
            if (
                moment(data.timeStart).diff(
                    moment().tz(values.timeZone),
                    "minutes"
                ) < 25
            ) {
                Swal.fire({
                    title: "Meeting Room",
                    text: "Please schedule a meeting atleast 30 minutes from now",
                    icon: "error",
                    showCancelButton: true,
                    cancelButtonColor: "#d33",
                    showConfirmButton: false,
                    cancelButtonText: "Close",
                    customClass: {
                        cancelButton: "order-1 right-gap",
                        confirmButton: "order-2",
                        denyButton: "order-3",
                    },
                });
            } else {
                dispatch(
                    createLiveStreamRequest({
                        data: data,
                        history: null,
                    })
                );
            }
        } else {
            dispatch(
                createLiveStreamRequest({
                    data: data,
                    history: history,
                })
            );
        }
    };

    guestUsers = allUsers.map((x) => {
        x.avatar = x.attachments;
        return x;
    });

    if (!IsNullOrEmpty(searchText)) {
        guestUsers = guestUsers.filter((x) => {
            return (
                x.fullName.toLowerCase().indexOf(searchText.toLowerCase()) > -1
            );
        });
    }

    var timeZones = moment.tz.names();

    function copyToClipboard() {
        /* Get the text field */
        var copyText = document.getElementById("myInput");

        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        navigator.clipboard.writeText(copyText.value);

        /* Alert the copied text */
        toastr.success("Copied the referral code", "Copied to Clipboard");
    }

    const shareUrl =
        process.env.REACT_APP_URL + "/video/" + livestream._id;

    return (
        <main className={classes.main}>
            <Dialog
                PaperProps={{
                    style: {
                        background: "none",
                        boxShadow: "none",
                    },
                }}
                maxWidth="sm"
                fullWidth
                open={showSummary}
            >
                <DialogContent>
                    <Card elevation={0}>
                        <CardHeader
                            title={props.category.name}
                            subheader="Summary"
                            classes={{
                                primary: classes.dashboardSubTitle,
                                subheader: classes.dashboardTitle,
                            }}
                            className="px-4"
                            action={
                                <IconButton
                                    onClick={() => history("/")}
                                >
                                    <Close />
                                </IconButton>
                            }
                        />
                        <CardContent className="px-4">
                            <List disablePadding>
                                <ListItem disableGutters>
                                    <ListItemAvatar className="mr-2">
                                        <Avatar
                                            className={classes.bgAvatar}
                                            variant="square"
                                        >
                                            <img
                                                src={videoIcon}
                                                className="blue-img"
                                                width="32"
                                            />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        secondary={livestream.title}
                                        primary={"Title"}
                                        classes={{
                                            secondary:
                                                classes.dashboardSubTitle,
                                            primary: classes.dashboardTitle,
                                        }}
                                    />
                                </ListItem>
                                <ListItem disableGutters>
                                    <ListItemAvatar className="mr-2">
                                        <Avatar
                                            className={classes.bgAvatar}
                                            variant="square"
                                        >
                                            <img src={calendarIcon} />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        classes={{
                                            secondary:
                                                classes.dashboardSubNormalTitle,
                                            primary: classes.dashboardTitle,
                                        }}
                                        secondary={moment(
                                            livestream.timeStart
                                        ).format("lll")}
                                        primary={"When"}
                                    />
                                </ListItem>
                                <ListItem disableGutters>
                                    <ListItemAvatar className="mr-2">
                                        <Avatar
                                            className={classes.bgAvatar}
                                            variant="square"
                                        >
                                            <img src={descIcon} />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        classes={{
                                            secondary:
                                                classes.dashboardSubTitle,
                                            primary: classes.dashboardTitle,
                                        }}
                                        secondary={livestream.contents}
                                        primary={"Description"}
                                    />
                                </ListItem>
                            </List>
                            {/* {
            livestream.guestInfo.length > 0 ?
              <>
                <h4 className="my-1 text-bold text-medium">Guest List</h4>
                {
                  livestream.guestInfo.map((x) => {
                    return <Chip className="m-2" icon={<Person />} color="primary" label={"@" + x.userName}></Chip>
                  })
                }
              </>
              : <></>
          }
          <br />
          {
            emails.length > 0 ?
              <>
                <h4 className="my-1 text-bold text-medium">Email List</h4>
                {
                  livestream.emails.map((x) => {
                    return <Chip className="m-2" icon={<Email />} color="primary" label={x}></Chip>
                  })}
              </>
              : <></>
          } */}
                            <br />
                            <TextField
                                fullWidth
                                variant="outlined"
                                disabled
                                className="my-2"
                                id="myInput"
                                value={shareUrl}
                                label="Meeting link"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <FileCopy
                                                onClick={() =>
                                                    copyToClipboard()
                                                }
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </CardContent>
                    </Card>
                </DialogContent>
            </Dialog>

            <Grid container className="h-[100%]">
                <Grid item xs={12} sm={12} lg={8} md={8}>
                    <Grid container className="pb-4">
                        <Grid item xs={12} sm={12} className="mb-2">
                            <Stepper
                                style={{ background: "transparent" }}
                                activeStep={activeStep}
                                alternativeLabel
                            >
                                {steps.map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel
                                            color={
                                                index === activeStep
                                                    ? theme.palette.secondary
                                                        .main
                                                    : theme.palette.primary
                                                        .contrastText
                                            }
                                        >
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Grid>
                        <Grid item sm={12} xs={12} className={classes.endDiv}>
                            <Grid container alignItems="center">
                                <Grid item xs={12} sm={12}>
                                    {getStepContent(activeStep)}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} lg={4} md={4}>
                    <Box className="side-image-box">
                        <img
                            src={
                                activeStep === 1
                                    ? pic1
                                    : activeStep === 2
                                        ? pic2
                                        : activeStep === 3
                                            ? pic3
                                            : pic
                            }
                            alt="pic"
                            className="img-responsive  rounded-xl"
                        />
                    </Box>
                </Grid>
            </Grid>
        </main>
    );
}
